<template>
    <div class="pa-0 ma-0">
        <v-chip :color="propriedadesChip.background" :text-color="propriedadesChip.color" :disabled="true">
            {{ situacaoAMostrar | filtroSituacaoAnaliseCredenciamento}}
            <v-tooltip v-if="!existeSolicitacaoEmAberto" bottom>
                <template v-slot:activator="{ on }">
                    <v-icon size="15" right v-on="on">{{propriedadesChip.icon}}</v-icon>
                </template>
                <span>{{ propriedadesChip.tooltip_message }}</span>
            </v-tooltip>
            <v-tooltip v-else bottom>
                <template v-slot:activator="{ on }">
                    <v-icon size="15" right v-on="on" @click="openDialog">{{propriedadesChip.icon}}</v-icon>
                </template>
                <span>{{ propriedadesChip.tooltip_message }}</span>
            </v-tooltip>
        </v-chip>

        <v-dialog v-model="showDialog" persistent max-width="700">
            <v-card>
                <v-card-title class="primary modal-title header-style" primary-title>
                    <div>Motivo Solicitação</div>
                    <div>{{ nomeFornecedor }}</div>
                </v-card-title>

                <v-card-text class="scrollable-content">
                    <v-expansion-panel popout v-model="panel">
                        <v-expansion-panel-content
                            v-for="(solicitacao) in solicitacoes"
                            :key="solicitacao.id"
                        >
                            <template v-slot:header>
                                <div>
                                    <span><strong>Documento:</strong></span>
                                    {{ solicitacao.descricao }}
                                </div>
                            </template>
                            <v-card>
                                <v-card-text class="grey lighten-3">
                                    <span><strong>Motivo:</strong></span>
                                    {{solicitacao.motivoReenvio}}
                                </v-card-text>
                            </v-card>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-card-text>

                <v-card-actions class="acoes justify-space-between">
                    <v-btn class="ml-3" color="#777" flat @click="closeDialog">
                        Voltar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>

export default {
    name: 'SituacaoPill',
    props: {
        situationText: String,
        nomeFornecedor: String,
        solicitacoes: {
            type: Array,
            default: () => []
        }
    },
    data: () => {
        return {
            situacoes: {
                CREDENCIADO: {
                    color: '#51a806',
                    background: 'transparent',
                    icon: 'check_circle_outline',
                    tooltip_message: 'Participante credenciado'
                },
                NAO_CREDENCIADO: {
                    color: '#ec3333',
                    background: 'transparent',
                    icon: 'highlight_off',
                    tooltip_message: 'Participante não credenciado'
                },
                AGUARDANDO_ENVIO: {
                    color: 'warning',
                    background: 'transparent',
                    icon: 'info_outline',
                    tooltip_message: 'Aguardando envio do documento pelo participante'
                },
                REENVIADO: {
                    color: '#be6100',
                    background: 'transparent',
                    icon: 'info_outline',
                    tooltip_message: 'Documento enviado pelo participante'
                },
                AGUARDANDO_ANALISE: {
                    color: '#1e1d1d',
                    background: 'transparent',
                    icon: 'schedule',
                    tooltip_message: 'Documentação ainda não analisada'
                }
            },
            showDialog: false,
            panel: null
        }
    },
    computed: {
        propriedadesChip() {
            return this.situacoes[this.situacaoAMostrar] || this.situacoes['AGUARDANDO_ENVIO']
        },
        situacaoAMostrar() {
            if (['NAO_CREDENCIADO', 'CREDENCIADO'].includes(this.situationText)) return this.situationText

            if (this.solicitacoes.length > 0) {
                return this.solicitacoes.every(s => 'REENVIADO' === s.situacao) ? 'REENVIADO' : 'AGUARDANDO_ENVIO'
            }

            return this.situationText
        },
        existeSolicitacaoEmAberto() {
            return this.solicitacoes.length > 0 && this.situacaoAMostrar !== 'AGUARDANDO_ANALISE'
        }

    },
    methods: {
        closeDialog() {
            this.showDialog = false
            this.panel = null
        },
        openDialog() {
            this.showDialog = true
        }
    },
};
</script>

<style scoped>
.scrollable-content {
    max-height: 250px; /* Adjust the height as needed */
    overflow-y: auto;
}

.header-style {
    display: flex;
    justify-content: space-between;
}
</style>